<template>
	<div class="container">
		<div class="main rank">
			<div class="top">
				<div class="title">Ranking de audiencia</div>
				<div class="subTitle">Habbo.com.br<div class="icon" style="background-image: url();"></div></div>
			</div>
			<div class="content">
				<div class="box" v-for="fs in rank" :key="fs.position" @click="$store.state.player = true, audio(fs.id)">
					<div class="boll" :style="{background: fs.cor}">
						<div :style="{backgroundImage: 'url('+fs.icon+')'}"></div>
						<span>{{fs.sigla}}</span>
					</div>
					<div class="position">
						<div class="icon" :style="{backgroundImage: 'url(img/'+fs.iconRank+')'}"></div>
						<span>&nbsp;{{fs.position}}</span>
					</div>
					<a :href="fs.link" target="_blank" rel="noopener noreferrer"><div class="name fs">{{fs.fasite}}</div></a>
					<div class="name" @click="this.audio(fs.id)"><span>com</span><br>{{fs.locutor}}</div>
					<div class="ouvintes"><i class="fa-solid fa-headphones-simple"></i>&nbsp; <span>{{fs.ouvintes}}</span> ouvintes</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {base} from '../../var.js'
import Player from './player.vue'
import axios from 'axios';

export default {
	name: 'RankItem',
	mixins: [Player],
	conponemts:{
	},
	data() {
		return {
			rank: [],
		}
	},
	methods: {
		async getRank() {
			const req = await axios.get(base+"rank");
			this.rank = req.data.rank;
		},
	},
	mounted: function() {
		setInterval(() => {
			this.getRank();
		}, 20000);
		this.getRank();
	}
}
</script>

<style scoped>
.main .content {
	position: relative;
	left: 0;
	display: flex;
	justify-content: space-around;
	width: 100%;
	height: auto;
}
.main.rank {width: 80%;}

.main .content .box {
	position: relative;
	width: 120px;
	height: 200px;
	padding: 0 5px;
	margin-top: 40px;
	transition: all 5s ease;
}

.main .content .box .boll {
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 90px;
	height: 90px;
	border-radius: 50%;
	font-size: 22px;
	font-weight: 600;
	color: #fff;
	left: 10px;
}

.main .content .box .boll div {
	width: 20px;
	height: 20px;
	background-position: center;
	background-repeat: no-repeat;
	background-size: 85%;
	opacity: 1;
	visibility: visible;
	display: block;
}
.main .content .box:hover .boll div {visibility: hidden;opacity: 0;display: none;transition: all 5s ease;}

.main .content .box .boll span {visibility: hidden;opacity: 0;display: none;user-select: none;}
.main .content .box:hover .boll span {visibility: visible;opacity: 1;display: block;transition: all 5s ease;}

.main .content .box .position {
	display: flex;
	justify-content: center;
	width: 100%;
	height: 20px;
	line-height: 20px;
	font-size: 14px;
	font-weight: 600;
	margin-top: 10px;
}

.main .content .box .position .icon {
	float: left;
	width: 11px;
	height: 14px;
	background-position: center;
	margin-top: 3px;
}

.main .content .box .name.fs {height: auto; line-height: 20px;}

.main .content .box .name {
	float: left;
	width: 100%;
	height: 40px;
	line-height: 20px;
	margin-top: 5px;
	font-size: 14px;
	font-weight: 600;
	text-align: center;
	white-space: nowrap;
}
.main .content .box .name span {font-weight: 400;font-size: 12px;}

.main .content .box .ouvintes {
	font-size: 13px;
	float: left;
	width: 100%;
	height: 20px;
	line-height: 20px;
	text-align: center;
	margin-top: 8px;
}
.main .content .box .ouvintes span {font-weight: 600;}

</style>